import { SdgLensData } from '@upright/ui/common/upright/core/impact-lenses/sdg/types';
import { ImpactLensType } from '@upright/common/impact-lenses/types';
import { useCarouselContext } from '../../../impact-lens-profile/context';

export function useSdgLensContext() {
  const context = useCarouselContext<ImpactLensType.SDGS>();
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  if (context.lensType === ImpactLensType.SDGS) {
    return {
      ...context,
      data: context.data as SdgLensData,
    };
  }
  return undefined;
}
